import React from 'react';
import * as Sentry from '@sentry/browser';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { Loader } from '@bottomless/common/components';
import { getMeAction } from '../store';
import { useVendorLock } from '@bottomless/common/hooks';

const setupIdentity = user => {
  if (/@bottomless.com$/.test(user.local.email)) {
    return;
  }

  const { _id, alertSettings, local, onboardingState } = user;

  if (window.hj) {
    window.hj('identify', _id, {
      email: user.local.email,
      username: `${user.first_name} ${user.last_name}`,
      local,
      alertSettings,
      onboardingState,
    });
  }
};

const IsExternalSubscriptionOnPublicPageComponent = ({ children, me, isAuth, getMe }) => {
  const vendor = useVendorLock();

  useEffect(() => {
    getMe();
  }, [getMe]);

  if (me) {
    Sentry.configureScope(scope => {
      scope.setUser({ id: me._id, email: me.local.email, username: `${me.first_name} ${me.last_name}` });
    });

    setupIdentity(me);
  }

  if (!isAuth) {
    return <Loader fullPage />;
  }

  if (me?.vendor_id && !vendor) {
    return <Loader fullPage />;
  }

  if (me?.vendor_id && vendor?.shopifyPortalUrl) {
    window.location.href = vendor.shopifyPortalUrl;
    return null;
  }

  return children;
};

IsExternalSubscriptionOnPublicPageComponent.propTypes = {
  children: PropTypes.node.isRequired,
  me: PropTypes.object,
  getMe: PropTypes.func.isRequired,
  isAuth: PropTypes.bool.isRequired,
};

export const IsExternalSubscriptionOnPublicPage = connect(
  ({ user: { me }, auth: { isAuth } }) => ({ me, isAuth }),
  dispatch => ({ getMe: () => dispatch(getMeAction()) })
)(IsExternalSubscriptionOnPublicPageComponent);
